module.exports = __webpack_public_path__ + "img/pin.996fbfcb.svg";